import { Button, Modal } from 'antd';
import React, { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useForceUpdate } from '../../../../../../shared/hooks/useForceUpdate';
import { clearNewAdmissionState, resetDetailNav, setAdmissionFormType, setIsSuccessModalNewAdmission, setSelectedTab } from '../../../../../../store/actions/newAdmissionAction';
import { ReactComponent as HomeIcon } from '../../../../../../assets/images/svg/i_home.svg';
import { ReactComponent as RoundTickIcon } from '../../../../../../assets/images/svg/i_round_tick.svg';
import { getAdmissionFormType, getIsPageNameNewAdmission } from '../../../service/crmUtils';
import { RootState } from '../../../../../../store';
import { PayerInitialState } from '../../../../../../store/models/payerListModel';
import { base64UrlEncode, canActivate } from '../../../../../../utils/utility';
import { NewAdmissionState } from '../../../../../../store/models/newAdmissionModel';
import ApplicationDetail from '../../../../../../shared/services/applicationDetail.service';
import { setClaimData, setLinkAbhaClicked } from '../../../../../../store/actions/claimDetailsAction';
import { authFeatureConstants, DISCHARGE_CONTEST_MESSAGE } from '../../../../../../shared/constants/commonConstants';
import { ApplicationDetailModel } from '../../../../../../store/models/applicationDetailModel';
import { ReactComponent as ABHI_logo } from '../../../../../../assets/images/svg/ABHI-logo.svg';
import { actions } from '../../../../../../shared/constants/crmConstants';

const SuccessModal = ({ isModalVisible, setIsModalVisible, form, claimDetail, isNew, isResubmitted }: any): ReactElement => {
  const history = useHistory();
  const dispatch = useDispatch();
  const forceUpdate = useForceUpdate();
  const { payer, payer: { name: payerName, id: payerId, productCode, isRpaPayer, isInitialDischargeEnabledPayer } } =
    useSelector((state: RootState): PayerInitialState => state?.payerList || {});
  const { linkedToAbha, isClaimDocLinkedToABDM, payerClaimNo, isDischargeContestCTA } =
    useSelector((state: RootState): any => state?.admissionDetails?.claimDetails || {});
  const { hospActionID, isDaycareCase } = useSelector((state: RootState): NewAdmissionState => state?.newAdmission || {});
  const appDetail = useSelector((state: RootState): ApplicationDetailModel => state?.applicationDetail);
  const claimStatus = isNew ? 'submitted' : isResubmitted ? 're-submitted' : 'updated';

  const claimMessage = (
    <p>
      Claim successfully {claimStatus} to <b>{payerName || 'Payer'}</b>
    </p>
  );
  const gotoInPatient = (): void => {
    setIsModalVisible(false);
    Modal.destroyAll();
    history.replace('/claims/in-patient/');
  };

  const gotoClaimDetail = (): void => {
    setIsModalVisible(false);
    Modal.destroyAll();
    // on click of claim detail button clearing the redux and resetting
    //  local storage to get updated values in Claimdetail api
    localStorage?.removeItem('claimDetailResponse');
    dispatch(setClaimData({}));
    history.replace(`/claims/in-patient/detail/${claimDetail}`);
  };

  const createNewAdmission = (): void => {
    setIsModalVisible(false);
    Modal.destroyAll();
    form.resetFields();
    dispatch(setSelectedTab(0));
    dispatch(resetDetailNav());
    dispatch(setAdmissionFormType(getAdmissionFormType(payer)));
    forceUpdate();
    dispatch(clearNewAdmissionState());
    dispatch(setIsSuccessModalNewAdmission(true));
  };

  const onLinkAbha = (): void => {
    dispatch(setLinkAbhaClicked(true));
    setIsModalVisible(false);
    Modal.destroyAll();
    const isCancel = false;
    const payerClaimNumber = payerClaimNo || '';
    const uniquePayerId = `${payerId}${productCode || ''}`;
    const providerId = ApplicationDetail?.instance?.getProviderId();
    history.replace(`/claims/in-patient/detail/${base64UrlEncode(`${base64UrlEncode(payerClaimNumber)}/${hospActionID}/${payerId}/${uniquePayerId}/${productCode}/${isCancel}/${providerId}`)}`);
  };

  const footerButton = (): ReactElement[] => {
    const footerArray: ReactElement[] = [
      <Button data-testid="goto-inpatient-list" key="gotoInpatient" onClick={gotoInPatient}>
        <HomeIcon className="fill-primary v-align-middle" />&nbsp; Go to In-Patient Desk
      </Button>,
    ];
    if (claimDetail) {
      footerArray.push(
        <Button data-testid="goto-claimdetail" key="gotoDetail" type="primary" onClick={gotoClaimDetail}>
          Claim Detail
        </Button>,
      );
    }
    if (getIsPageNameNewAdmission(history.location.pathname)) {
      footerArray.push(
        <Button data-testid="goto-newadmission" key="gotoNewadmission" type="primary" onClick={createNewAdmission}>
          + New Admission
        </Button>,
      );
    }
    return footerArray;
  };
  const successModalMsg = (
    <>
      <div className="text-success" data-testid="success-message">
        {isDischargeContestCTA ? (
          <p className="mb-lg">{DISCHARGE_CONTEST_MESSAGE}</p>
        ) : isRpaPayer ? (
          <p>We have received your claim submission request</p>
        ) : isInitialDischargeEnabledPayer && isDaycareCase ? (
          <div className="text-center">
            <ABHI_logo className="centered-image" />
            <p>
              <i className="express-textFont">express</i>
              <b className="discharge-textFont">{actions.DISCHARGE}</b>
            </p>
            {claimMessage}
          </div>
        ) : (
          <>{claimMessage}</>
        )}
      </div>
      {process.env.REACT_APP_ABHA_LINK_CLAIM_DETAILS === 'true' &&
        canActivate(authFeatureConstants.ABDM_HIU) &&
        canActivate(authFeatureConstants.EDIT_ABDM_HIU) &&
        appDetail?.getHipId() && (
          <div className="abha-link-container mb-lg">
            {linkedToAbha === 'True' && isClaimDocLinkedToABDM ? (
              <span className="abha-link-text">
                Health Records have also been linked with ABHA
              </span>
            ) : (
              <Button
                type="link"
                className="abha-link-button"
                onClick={onLinkAbha}
              >
                Link Health Records with ABHA
              </Button>
            )}
          </div>
        )}
      {footerButton()}
    </>
  );
  function success(): void {
    Modal.success({
      content: successModalMsg,
      okText: null,
      icon: <RoundTickIcon className="fill-success" />,
      className: 'success-modal text-center',
      width: 'max-content',
    });
  }
  return (
    isModalVisible && <>
      {success()}
    </>
  );

};

export default SuccessModal;
